(function (angular) {
    angular.module('bizPartEngage').controller('modules.goals.team', indexController);

    indexController.$inject = ["modules.goals.service", "bizUser"];

    function indexController(goalService, bizUser) {
        var vm = this
        vm.UserId = bizUser.getLoggedInUser().Id;
        vm.ExpandStatusStorageKey = 'TEAM_USERPROGRESS_EXPAND_STATUS_' + vm.UserId;
        vm.ExpandedUserProgress = [];

        vm.GetCurrentProgress = GetCurrentProgress;
        vm.GetGoalsForUsers = GetGoalsForUsers;
        vm.ToggleUserProgressExpanded = ToggleUserProgressExpanded;
        vm.StoreUserProgressExpandStatus = StoreUserProgressExpandStatus;     
        vm.RetrieveUserProgressExpandStatus = RetrieveUserProgressExpandStatus;

        function GetCurrentProgress() {
            goalService.GetProgressSum(true).then(GetProgressSumForUserCallback);

            function GetProgressSumForUserCallback(response) {
                var prg = BizPartCoreHelpers.getResponseValue(response);     
                for (var i = 0; i < prg.length; i++) {
                    prg[i].Expanded = vm.ExpandedUserProgress.indexOf(prg[i].UserId) >= 0;
                }                

                vm.UsersProgress = prg;
            }
        }

        function GetGoalsForUsers() {
            goalService.GetGoalsForUsersInSameUnit().then(GetGoalsForUsersInSameUnitCallback);

            function GetGoalsForUsersInSameUnitCallback(response) {
                vm.UserGoals = BizPartCoreHelpers.getResponseValue(response);
            }
        }

        function ToggleUserProgressExpanded(progressItem) {
            progressItem.Expanded = !progressItem.Expanded;
            if (progressItem.Expanded) {
                if (vm.ExpandedUserProgress.indexOf(progressItem.UserId) < 0) {
                    vm.ExpandedUserProgress.push(progressItem.UserId);
                }
            } else {
                var index = vm.ExpandedUserProgress.indexOf(progressItem.UserId);
                if (index >= 0) {
                    vm.ExpandedUserProgress.splice(index, 1);
                }
            }

            vm.StoreUserProgressExpandStatus();
        }

        function StoreUserProgressExpandStatus() {
            setLocalStorage(vm.ExpandStatusStorageKey, JSON.stringify(vm.ExpandedUserProgress));
        }

        function RetrieveUserProgressExpandStatus() {
            var data = getLocalStorage(vm.ExpandStatusStorageKey);
            if (data) {
                vm.ExpandedUserProgress = JSON.parse(data);
            }
        }

        vm.$onInit = function () {     
            vm.RetrieveUserProgressExpandStatus();
            vm.GetCurrentProgress();
            vm.GetGoalsForUsers();
        }
    }

})(window.angular);
